import type { EffectParams } from '@swf/core/store';
import { select } from '@swf/core/store';

const signEula = async (
  payload: {
    marketingMailList?: boolean;
    useMailList?: boolean;
  },
  { dispatch, rootState, request }: EffectParams
) => {
  try {
    const useMailList = select.account.getEulaMarketingEnabled(rootState);
    await request({
      service: '/api/v1-preview/auth/eula/sign',
      method: 'POST',
      body: { useMailList, ...payload }
    });
  } catch (err) {
    dispatch.auth.logout({});
  }
};

export default signEula;
